"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectListConverter_1 = require("../../core/conversions/DataObjectListConverter");

var TreeInfoDTO_1 = require("../model/TreeInfoDTO");

var TreeInfoDTOConverter_1 = require("./TreeInfoDTOConverter");

var TreeInfoDTOConverterImpl =
/*#__PURE__*/
function (_TreeInfoDTOConverter) {
  _inherits(TreeInfoDTOConverterImpl, _TreeInfoDTOConverter);

  function TreeInfoDTOConverterImpl() {
    _classCallCheck(this, TreeInfoDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(TreeInfoDTOConverterImpl).apply(this, arguments));
  }

  _createClass(TreeInfoDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var converter = typescript_ioc_1.Container.get(DataObjectListConverter_1.DataObjectListConverter, {
        className: source.dataType
      });
      return new TreeInfoDTO_1.TreeInfoDTO(conversions.toClassReferenceId(source.id), source.level, conversions.toClassReferenceId(source.parentId), conversions.asObjectList(source, 'childrenIds', function (value) {
        return conversions.toClassReferenceId(value);
      }), source.dataType, converter.arrayToObject(source.data, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var converter = typescript_ioc_1.Container.get(DataObjectListConverter_1.DataObjectListConverter, {
        className: source.dataType
      });
      var result = {};
      Object.assign(result, {
        id: source.id,
        level: source.level,
        parentId: conversions.toDocumentReferenceId(source.parentId),
        childrenIds: source.childrenIds.map(function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        dataType: source.dataType,
        data: converter.objectToArray(source.data, conversions)
      });
      return result;
    }
  }]);

  return TreeInfoDTOConverterImpl;
}(TreeInfoDTOConverter_1.TreeInfoDTOConverter);

exports.TreeInfoDTOConverterImpl = TreeInfoDTOConverterImpl;